var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeathstar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    fill: "none",
    viewBox: "8.001 -56 496 496",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M256-56C119.033-56 8 55.033 8 192c.041 9.64.62 18.912 1.725 28.266C81.197 242.77 165.479 256 256 256s174.803-13.23 246.275-35.734A247.723 247.723 0 0 0 503.999 192C504 55.033 392.966-56 256-56zm64 232c-44.153 0-80-35.847-80-80s35.847-80 80-80 80 35.847 80 80-35.847 80-80 80zm175.29 80.264C424.712 276.539 343.341 288 256 288S87.287 276.54 16.711 256.264C45.06 362.02 141.3 440 256.001 440s210.94-77.98 239.288-183.736zM320 72c-13.246 0-24 10.754-24 24s10.754 24 24 24 24-10.754 24-24-10.754-24-24-24z",
    fill: "#363636"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeathstar);
export default __webpack_public_path__ + "static/media/deathstar.b53e58a945e7d91add350b708b38d98c.svg";
export { ForwardRef as ReactComponent };